var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('MenuItem',{staticClass:"menu",attrs:{"to":"/videos","target":"_blank"}},[_vm._v("Videos")]),_c('MenuItem',{staticClass:"menu",attrs:{"to":"/reviews"}},[_vm._v("Reviews")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }